module.exports = __webpack_public_path__ + "static/media/tutorial.576fd1da.mp4";